export default "__VITE_ASSET__T3$Tnw_k__"